import { useTranslation } from "react-i18next";
import {
  Checkbox,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import Paper from "@mui/material/Paper";
import Button from "@mui/material/Button";
import DeleteIcon from "@mui/icons-material/Delete";
import React from "react";
import { useStylesECDS } from "../../ward/forms/ecds/ecdsStyle";

export default function EscortList({ admit, deleteItem }) {
  const { t } = useTranslation();
  const classes = useStylesECDS();

  const escortList = admit.escortArray;

  return (
    escortList &&
    escortList.length > 0 && (
      <TableContainer component={Paper} className={classes.table}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell align="left">{t("No")}</TableCell>
              <TableCell>{t("Person Name")}</TableCell>
              <TableCell align="center">
                {t("Parental Responsibility")}
              </TableCell>
              <TableCell align="center">{t("Attended with child")}</TableCell>
              <TableCell align="right">{t("Age")}</TableCell>
              <TableCell align="right">{t("Relationship")}</TableCell>
              <TableCell align="right">{t("Contact Details")}</TableCell>
              <TableCell align="center">{t("Delete")}</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {escortList &&
              escortList.length > 0 &&
              escortList.map((row, index) => (
                <TableRow
                  key={row.id + index}
                  sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                >
                  <TableCell component="th" scope="row">
                    {index + 1}
                  </TableCell>
                  <TableCell component="th" scope="row">
                    {row.name}
                  </TableCell>
                  <TableCell align="center">
                    <Checkbox
                      checked={row.parentalResponsibility}
                      disabled={true}
                    />
                  </TableCell>
                  <TableCell align="center">
                    <Checkbox checked={row.attendedWithChild} disabled={true} />
                  </TableCell>
                  <TableCell align="right">{row.age}</TableCell>
                  <TableCell align="right">{row.relationship}</TableCell>
                  <TableCell align="right">{row.contact}</TableCell>
                  <TableCell align="center">
                    <Button onClick={() => deleteItem(index)}>
                      <DeleteIcon />
                    </Button>
                  </TableCell>
                </TableRow>
              ))}
          </TableBody>
        </Table>
      </TableContainer>
    )
  );
}
